import { type ObjectValuesUnionType } from '../../../utils/typing';

export const MissionEnrollmentButtonStatuses = Object.freeze({
  DEFAULT: 'DEFAULT',
  PASSIVE: 'PASSIVE',
  NOT_CONNECTED: 'NOT_CONNECTED',
});
export type MissionEnrollmentButtonStatus = ObjectValuesUnionType<typeof MissionEnrollmentButtonStatuses>;

export const MissionCardComplexeStatuses = Object.freeze({
  OPEN: 'OPEN',
  RUNNING: 'RUNNING',
  EXPIRED_BUT_PENDING_BETS: 'EXPIRED_BUT_PENDING_BETS',
  EXPIRED: 'EXPIRED',
  WON: 'WON',
});
export type MissionCardComplexeStatus = ObjectValuesUnionType<typeof MissionCardComplexeStatuses>;
